import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// utils
import apiSlice from "src/utils/api-slice";
// slices
import userReducer from "./slices/user";
// import planReducer from "./slices/plan";
import addressReducer from "./slices/address";
// import taskReducer from "./slices/task";
import carrierReducer from "./slices/carrier";
// import storeReducer from "./slices/store";
import transactionReducer from "./slices/transaction";
// import paymentReducer from "./slices/payment";
// import shippingRuleReducer from "./slices/shipping-rule";
// import packageReducer from "./slices/package";
// import orderReducer from "./slices/order";
// import pickupReducer from "./slices/pickup";
// import scanFormReducer from "./slices/scan-form";
// import automationReducer from "./slices/automation";
import otherReducer from "./slices/other";
import shipmentReducer from "./slices/shipment";
// import notificationReducer from "./slices/notification";
// import reportReducer from "./slices/report";
import errorReducer from "./slices/error";

// ----------------------------------------------------------------------

const rootPersistConfig = {
    key: "root",
    storage,
    keyPrefix: "redux-",
    whitelist: null // 持久化所有 reducer
};

const appReducer = combineReducers({
    // task: taskReducer,
    // notification: notificationReducer,
    // report: reportReducer,
    // payment: paymentReducer,
    shipment: shipmentReducer,
    // pickup: pickupReducer,
    // order: orderReducer,
    //
    user: userReducer,
    transaction: transactionReducer,
    // plan: planReducer,
    address: addressReducer,
    // store: storeReducer,
    carrier: carrierReducer,
    // package: packageReducer,
    // scanForm: scanFormReducer,
    // automation: automationReducer,
    // shippingRule: shippingRuleReducer,
    other: otherReducer,
    //
    error: errorReducer,
    //
    [ apiSlice.reducerPath ]: apiSlice.reducer
});

const rootReducer = (state, action) => {
    if (action.type === "RESET") {
        storage.removeItem("persist:root"); // for all keys defined in your persistConfig(s)

        return appReducer(undefined, action);
    }

    return appReducer(state, action);
};

// Persist Reducer
export default persistReducer(rootPersistConfig, rootReducer);
